<template>
  <div>
    <div
      class="wrapper-con"
      style=" display: flex; justify-content: center; padding-top: 20px; height: 100%;"
    >
      <div class="content">
        <div
          class="contxt"
          style="display: flex; flex-direction: column; overflow: hidden; height: 100%;"
        >
          <div class="overflowy">
            <div class="picture">
              <img
                src="data:image/png;base64,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"
              />
            </div>
            <div class="page-title">
              首页
            </div>
          </div>

          <div class="scrollCon" style="height: 650px;">
            <div class="scroll-box noRepeat ysize" style="min-height: 650px;">
              <div
                class="placeholder putItHere"
                :data-index="0"
                v-show="placeholder"
              >
                释放鼠标将组件添加到此处
              </div>

              <div
                class="dragArea list-group"
                v-for="(element, index) in moduleList"
                :key="index"
              >
                <div
                  class="mConfig-item on"
                  :class="selectIndex === index ? 'on' : ''"
                  @click.stop="moduleClick(index)"
                  @mouseenter="mouseovers(index)"
                  @mouseleave="mouseout"
                >
                  <div class="homeComb on">
                    <div>
                      <modlueSearch
                        :module="element"
                        v-if="element.type == 101"
                      />
                      <modlueBanner
                        :module="element"
                        v-if="element.type == 102"
                      />
                      <moduleNav :module="element" v-if="element.type == 103" />
                      <modlueGoods
                        :module="element"
                        v-if="element.type == 104"
                      />
                      <modlueRecommend
                        :module="element"
                        v-if="element.type == 105"
                      />
                      <modlueNotice
                        :module="element"
                        v-if="element.type == 106"
                      />
                      <modlueGuangGao
                        :module="element"
                        v-if="element.type == 107"
                      />
                      <modlueMenu
                        :module="element"
                        v-if="element.type == 108"
                      />
                      <modluePriceLog
                        :module="element"
                        v-if="element.type == 109"
                      />
                    </div>
                  </div>
                  <div class="delete-box" v-if="selectIndex === index">
                    <div class="handleType">
                      <div style="margin-bottom: 15px;" @click.stop="up">
                        <a-icon type="arrow-up" />
                      </div>

                      <div
                        style="margin-bottom: 15px;"
                        @click.stop="delectModule"
                      >
                        <a-icon type="delete" />
                      </div>

                      <div style="margin-bottom: 10px;" @click.stop="down">
                        <a-icon type="arrow-down" />
                      </div>
                    </div>
                  </div>
                  <div class="handle"></div>
                  <div class="delete-name" v-if="selectIndex === index">
                    {{ element.name }}
                  </div>
                </div>

                <div
                  class="placeholder putItHere"
                  :data-index="index + 1"
                  v-if="placeholder"
                >
                  释放鼠标将组件添加到此处
                </div>
              </div>
            </div>
          </div>
          <div class="overflowy">
            <div class="page-foot">

              <div v-if="this.footerData.list">
                <div
                  class="page-footer"
                  @click.stop="footerClick()"
                  :class="footerStatus ? 'footer_on' : ''"
                >
                  <div
                    class="foot-item"
                    v-for="(item, index) in footerData.list"
                    :key="index"
                  >
                    <div>
                      <img :src="item.icon" class="font-item_icon" />
                    </div>
                    <div>
                      <span style="color: rgb(246, 44, 44);font-size: 12px;">
                        {{ item.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else>
                <div
                  class="page-footer"
                  @click.stop="footerClick()"
                  :class="footerStatus ? 'footer_on' : ''"
                >
                  <div class="foot-item">
                    <div>
                      <img
                        src="@/assets/icon/home.png"
                        class="font-item_icon"
                      />
                    </div>
                    <span style="color: rgb(246, 44, 44);font-size: 12px;">
                      首页
                    </span>
                  </div>

                  <div class="foot-item">
                    <div>
                      <img
                        src="@/assets/icon/fenlei.png"
                        class="font-item_icon"
                      />
                    </div>
                    <span style="color: rgb(246, 44, 44);font-size: 12px;">
                      分类
                    </span>
                  </div>

                  <div class="foot-item">
                    <div>
                      <img
                        src="@/assets/icon/kefu.svg"
                        class="font-item_icon"
                      />
                    </div>
                    <span style="color: rgb(246, 44, 44);font-size: 12px;">
                      客服
                    </span>
                  </div>

                  <div class="foot-item">
                    <div>
                      <img
                        src="@/assets/icon/wode.png"
                        class="font-item_icon"
                      />
                    </div>
                    <span style="color: rgb(246, 44, 44);font-size: 12px;">
                      我的
                    </span>
                  </div>
                </div>
              </div>

              <div class="delete-box"></div>
              <div class="handle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="底部栏"
      :visible="dialogFooterVisible"
      @cancel="dialogFooterVisible = false"
    >
      <div class="footer_bottom">
        <div>
          <div
            class="item"
            v-for="(item, index) in footerData.list"
            :key="index"
          >
            <div class="delect-btn" @click="deleteFooter(item)">
              <i class="el-icon-circle-close" style="font-size: 24px;"></i>
            </div>
            <div class="move-icon">
              <span class="iconfont-diy"></span>
            </div>
            <div class="img-box" @click="openImageSelector(index)">
              <div class="upload-box" v-if="!item.icon">
                <i class="el-icon-plus" style="font-size: 45px;"></i>
              </div>

              <div class="upload-box" v-else>
                <img
                  :src="item.icon"
                  style="position: relative;width: 64px;height: 64px;"
                />
              </div>
            </div>
            <div class="info">
              <div class="info-item">
                <span class="span">标题</span>
                <div class="input-box">
                  <a-input placeholder="请输入标题" v-model="item.name" />
                </div>
              </div>
              <div class="info-item" @click.stop="openLink(index)">
                <span class="span">链接</span>
                <div class="input-box">
                  <el-input
                    v-model="item.link"
                    placeholder="请输入内容"
                    readonly
                    @click.stop="openLink(index)"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" @click.stop="handleFooter()">
            添加一行
          </el-button>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFooterVisible = false">
          保 存
        </el-button>
      </span>
    </a-modal>

    <!-- 公共图片 -->
    <HIMAGE ref="HImage" @imageCallback="imageCallback"></HIMAGE>

    <!-- 公共链接 -->
    <MLink ref="mlink" @linkCallback="linkCallback"></MLink>
  </div>
</template>

<script>
import HIMAGE from "@/components/IMAGE/index.vue";

// 移动端
import moduleNav from "@/views/template/mobile/module/nav/common.vue";
import modlueGoods from "@/views/template/mobile/module/goods/common.vue";
import modlueSearch from "@/views/template/mobile/module/search/common.vue";
import modlueBanner from "@/views/template/mobile/module/banner/common.vue";
import modlueRecommend from "@/views/template/mobile/module/recommend/common.vue";
import modlueNotice from "@/views/template/mobile/module/Notice/common.vue";
import modlueGuangGao from "@/views/template/mobile/module/guanggao/common.vue";
import modlueMenu from "@/views/template/mobile/module/menu/common.vue";
import modluePriceLog from "@/views/template/mobile/module/priceLog/common.vue";

import MLink from "@/components/Link/mindex.vue";

export default {
  name: "Module",

  props: ["moduleList", "footerData"],

  components: {
    HIMAGE,
    MLink,

    //组件
    moduleNav,
    modlueGoods,
    modlueSearch,
    modlueBanner,
    modlueRecommend,
    modlueNotice,
    modlueGuangGao,
    modlueMenu,
    modluePriceLog
  },
  data() {
    return {
      selectedLinkIndex: undefined,

      footerStatus: false,
      footerItem: {
        name: undefined,
        icon: undefined,
        link: undefined
      },

      dialogFooterVisible: false,

      placeholder: false,
      selectIndex: undefined, //选中
      activeIndex: undefined //当前活动active
    };
  },
  computed: {
    isFooterDataEmpty() {
      return !Array.isArray(this.footerData.list) || this.footerData.list.length === 0;
    }
  },
  methods: {
    //模块点击
    moduleClick(index) {
      this.footerStatus = false;

      this.selectIndex = index;

      this.activeIndex = index;

      this.$emit("moduleClick", index);
    },

    //底部模块点击
    footerClick() {
      this.footerStatus = true;

      this.dialogFooterVisible = true;
    },

    //鼠标移入模块
    mouseovers(index) {
      let top = event.target.getBoundingClientRect().top;
      this.$emit("moduleMouseovers", { top: top, index: index });
    },

    /**
     * 底部栏添加一行
     */
    handleFooter() {
      if (!this.footerData.list) {
        this.footerData.list = [];
      }

      let row = { name: "标题", link: "", icon: "" };

      this.footerData.list.push(row);


      this.$forceUpdate();
    },

    /**
     * 删除
     */
    deleteFooter(item) {
      // 确保至少保留一个元素
      // if (this.footerData[1].list.length <= 1) {
      //   this.$message({
      //     showClose: true,
      //     message: "至少保留一个！"
      //   });
      //   return;
      // }

      var index = this.footerData.list.indexOf(item);
      if (index !== -1) {
        this.footerData.list.splice(index, 1);
      }

      this.$forceUpdate();
    },

    //鼠标离开模块
    mouseout() {
      this.$emit("moduleMouseout");
    },

    delectModule() {
      this.selectIndex = undefined;
      this.moduleList.splice(this.activeIndex, 1);
      this.$emit("deleteMouseout");
    },

    //上移
    up() {
      //移动
      this.moduleList.splice(
        this.activeIndex - 1,
        0,
        this.moduleList[this.activeIndex]
      );

      //删除原来的
      this.moduleList.splice(this.activeIndex + 1, 1);

      this.selectIndex = this.activeIndex - 1;

      this.activeIndex = this.activeIndex - 1;

      this.$forceUpdate();
    },

    //下移
    down() {
      this.moduleList.splice(
        this.activeIndex + 2,
        0,
        this.moduleList[this.activeIndex]
      );
      this.moduleList.splice(this.activeIndex, 1);

      this.selectIndex = this.activeIndex + 1;

      this.activeIndex = this.activeIndex + 1;

      this.$forceUpdate();
    },

    /**
     * 上传图片
     */
    openImageSelector(index) {
      this.selectedIndex = index;

      this.$refs.HImage.handleAdd();
    },

    //图片选择返回
    imageCallback(row) {
      // 获取要更新的行
      const updatedRow = {
        ...this.footerData.list[this.selectedIndex],
        icon: row.imgUrl
      };

      // 使用 Vue 的 $set 方法更新数组中的对象
      this.$set(this.footerData.list, this.selectedIndex, updatedRow);

      this.$forceUpdate();
    },

    /**
     * 打开链接组件
     */
    openLink(index) {
      this.selectedLinkIndex = index;

      this.$refs.mlink.handleAdd();
    },

    /**
     * 链接选择
     */
    linkCallback(link) {
      // 获取要更新的行
      const updatedRow = {
        ...this.footerData.list[this.selectedLinkIndex],
        link: link
      };

      // 使用 Vue 的 $set 方法更新数组中的对象
      this.$set(this.footerData.list, this.selectedLinkIndex, updatedRow);

      this.$forceUpdate();
    }
  }
};
</script>
<style>
.putItHere {
  height: 40px;
  text-align: center;
  line-height: 40px;
  border: 1px dashed #1890ff;
  color: #1890ff;
  background-color: #edf4fb;
}

.page-footer {
  display: flex;
  background: #fff;
  padding-top: 0px;
  padding-bottom: 0px;
  background: rgb(255, 255, 255);
}

.font-item_icon {
  width: 24px;
  height: 24px;
}

.page-footer .foot-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50px;
}

/* ===================================新的=================================== */
.footer_bottom .item {
  position: relative;
  display: flex;
  background: #f9f9f9;
  align-items: center;
  padding: 16px 20px 16px 0;
  margin-bottom: 16px;
  border-radius: 3px;
}

.footer_bottom .item .delect-btn {
  position: absolute;
  right: -13px;
  top: -16px;
}

.footer_bottom .item .delect-btn .iconfont-diy {
  font-size: 25px;
  color: #ccc;
}

.footer_bottom .item .move-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  cursor: move;
}

.iconfont-diy {
  color: #ddd;
  font-size: 16px;
}

.footer_bottom .item .img-box {
  position: relative;
  width: 64px;
  height: 64px;
}

.footer_bottom .item .info {
  flex: 1;
  margin-left: 22px;
}

.footer_bottom .item .info .info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.footer_bottom .item .info .info-item .span {
  width: 40px;
  font-size: 12px;
  color: #999;
}

.footer_bottom .item .info .info-item .input-box {
  flex: 1;
}

.footer_on {
  border: 2px solid #1890ff;
  box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3);
}
</style>
